import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { onLoggedout, showItem } from '@modules/shared/shared.component';
import {ApiService} from '@modules/shared/services/api.service';
import {TranslocoService} from '@ngneat/transloco';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
import { UnreadMsgService } from '@app/modules/shared/services/unread-msg.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  pushRightClass = 'push-right';
  username: string;
  unreadCount = 0;

  subscriptionAvatar: Subscription;
  selectedLang = localStorage.ss_user_lang;
  logoMiniUrl = `${environment.api.logosUrl}/logo-mini.png`
  config;
  showItem = showItem

  constructor(public router: Router,
     private apiService: ApiService,
     private service: TranslocoService,
      private toastr: ToastrService,
      private unreadService: UnreadMsgService
     ) {
     this.config = environment.client;
    this.router.events.subscribe(val => {
        if (
            val instanceof NavigationEnd &&
            window.innerWidth <= 992 &&
            this.isToggled()
        ) {
            this.toggleSidebar();
        }
    });
    this.unreadService.selectedUnread$.subscribe((value) => {
      this.getUnreadCount();
    });
  }

  ngOnInit() {
    this.username = localStorage.username;
    this.getUnreadCount();
  }
  getUnreadCount() {
    this.apiService.getUnreadMessages().subscribe(response => {
      if (response.success) {
        this.unreadCount = response.data;
      }
    });
  }
  changeSiteLanguage() {
    this.service.setActiveLang(this.selectedLang);
    this.apiService.changeUserLanguage({'new_lang': this.selectedLang}).subscribe(response =>{
      if (response.success) {
        this.toastr.success('', this.service.translate('common.language_changed'));
        localStorage.setItem('ss_user_lang', this.selectedLang);
      }
    });
  }

  ngOnDestroy() {}

  isToggled(): boolean {
    console.log(1);
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
  }
  toggleSidebar() {
    console.log(2);
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }
  rltAndLtr() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle('rtl');
  }
  onClickLoggedout() {
    this.apiService.logout().subscribe(value => {
      onLoggedout();
    });
  }

}
